import React, {Component} from "react";
import "./MonthlyReport.scss"
import GroupNav from '../DownloadReport/GroupNav';
import DatePicker from 'react-datepicker';
import moment from "moment";
import {schemaTypes} from '../../../../constants/constants'
import ReportAPIs from "../../../../APIs/ReportAPIs";
import GroupTable from '../GroupReport/groupTable';

class MonthlyReport extends Component{
    constructor(props){
        super(props)
        this.props = props
        this.state = {
            utilization_type: "",
            reportName: "",
            dropdownOpen: false,
            startDate: moment().subtract(1, "month").startOf("day").toDate(),
            endDate: moment().subtract(1, "day").endOf("day").toDate(),
            selectAllGroups: false,
            groups: [],
            selectedGroup: {},
            vehicleIds: [],
            tableData: [],
            columns: [],
            busy: false,
            errorPage: false,
        }
        this.group = []
        
        // Header name mapping: API key -> Display name
        this.headerMapping = {
            'regno': 'Reg No',
            'vinno': 'VIN No',
            'make': 'Make',
            'model': 'Model',
            'month': 'Month',
            'totaldistance': 'Total Distance(KM)',
            'totalsoconsumed': 'Total SoC Consumed(%)',
            'startodometer': 'Start Odometer(KM)',
            'endodometer': 'End Odometer(KM)',
            // Add more mappings as needed
        };
    }

    componentDidMount(){
        this.handleClickOutside = (e) => {
            let container = document.querySelector('.mrc-report-type');
            if (container && !container.contains(e.target)) {
                this.setState({dropdownOpen: false});
            }
        };
        document.addEventListener('mousedown', this.handleClickOutside);
        
        // Fix gap between tabs and content
        window.$('.rw-container').css('top', '53px');

        // Initialize group tree (without collecting vehicles)
        let group = this.props.props.groupTree;
        if(!group.path){
            group.path = "/0/";
            group.ppath = "/0/";
        }
        this.group = group;
        // Initialize groups state without navigating (no vehicle collection on load)
        let rootGroupPath = "";
        let nav = [];
        nav.push(this.group);
        this.setState({groups: nav});
    }

    componentWillUnmount() {
        if (this.handleClickOutside) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
        
        // Remove the top style when component unmounts
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });
    }

    toggleDropdown = () => {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    };

    handleOptionClick = (value, name) => {
        this.setState({
            utilization_type: value,
            reportName: name,
            dropdownOpen: false,
        });
    };

    getReportType = () => {
        const reportTypes = [
            { key: "utilization-report", name: "Utilization Report" },
            // { key: "utilization-graph", name: "Utilization Graph" } // TODO: Will be developed later
        ];
        
        return reportTypes.map((report, index) => {
            return (
                <div
                    key={index}
                    className="dropdown-option"
                    onClick={() => this.handleOptionClick(report.key, report.name)}
                >
                    {report.name}
                </div>
            );
        });
    };

    handleStartDate = (date) => {
        // Set start date to 00:00 (midnight) of the selected date
        const startDateWithTime = moment(date).startOf("day").toDate();
        this.setState({startDate: startDateWithTime})
    }

    handleEndDate = (date) => {
        // Set end date to 23:59 (11:59 PM) of the selected date
        const endDateWithTime = moment(date).endOf("day").toDate();
        this.setState({endDate: endDateWithTime})
    }

    // Recursively collect vehicle IDs from a group and all its sub-groups
    collectVehicleIdsFromGroup = (group) => {
        let vehicleIds = [];
        
        if (!group) {
            return vehicleIds;
        }

        // Collect vehicles from current group
        if (group.vehicles && Array.isArray(group.vehicles)) {
            group.vehicles.forEach(vehicle => {
                const vehicleId = vehicle.id || vehicle.vehicleid || vehicle.userid;
                if (vehicleId) {
                    vehicleIds.push(vehicleId);
                }
            });
        }

        // Recursively collect vehicles from all sub-groups
        if (group.children && Array.isArray(group.children)) {
            group.children.forEach(childGroup => {
                if (childGroup.groupid != null) {
                    const childVehicleIds = this.collectVehicleIdsFromGroup(childGroup);
                    vehicleIds = [...vehicleIds, ...childVehicleIds];
                }
            });
        }

        return vehicleIds;
    }

    navigate = (group) => {
        let rootGroupPath = "";
        let path = group.path;
        let pathArray = path.split("/");
        pathArray.splice(0,1);
        pathArray = pathArray.splice(0, pathArray.length-1);
        let currentPath = rootGroupPath;
        let nav = [];
        let currentNode = this.group;
        nav.push(currentNode);
        for(let idx in pathArray){
            currentPath += "/" + pathArray[idx];
            for(let jdx in currentNode.children){
                if(currentNode.children[jdx].path === currentPath + "/"){
                    currentNode = currentNode.children[jdx];
                    if(!("children" in currentNode))
                        currentNode.children = [];
                    nav.push(currentNode);
                    break;
                }
            }
        }
        
        // Collect vehicle IDs from the selected group and all its sub-groups
        const vehicleIds = this.collectVehicleIdsFromGroup(group);
        
        this.setState({groups: nav, selectedGroup: group, vehicleIds: vehicleIds}, () => {
            console.log("Selected Group:", group.name || group.vehicleno || "Root");
            console.log("Vehicle IDs from selected group and sub-groups:", vehicleIds);
            console.log("Total vehicles:", vehicleIds.length);
        });
    }

    toggleSelectAllGroups = () => {
        const newSelectAllGroups = !this.state.selectAllGroups;
        
        if (newSelectAllGroups) {
            // Collect all vehicles from the main group tree and all sub-groups
            const vehicleIds = this.collectVehicleIdsFromGroup(this.group);
            this.setState({
                selectAllGroups: true, 
                vehicleIds: vehicleIds,
                selectedGroup: {} // Clear selected group when selecting all
            }, () => {
                console.log("Select All Groups: Enabled");
                console.log("All Vehicle IDs from main group and all sub-groups:", vehicleIds);
                console.log("Total vehicles:", vehicleIds.length);
            });
        } else {
            // Clear vehicle IDs and selected group when unchecking
            this.setState({
                selectAllGroups: false, 
                vehicleIds: [],
                selectedGroup: {}
            }, () => {
                console.log("Select All Groups: Disabled");
                console.log("Vehicle IDs cleared");
            });
        }
    }

    // Validate if all required fields are filled
    isFormValid = () => {
        // Check if group/vehicles are selected
        // Either "Select All Groups" is checked OR a specific group is selected (with valid groupid)
        const hasGroupOrVehicles = this.state.selectAllGroups || 
            (this.state.selectedGroup && 
             this.state.selectedGroup.groupid !== undefined && 
             this.state.selectedGroup.groupid !== null &&
             Object.keys(this.state.selectedGroup).length > 0);
        
        // Check if start date is selected
        const hasStartDate = this.state.startDate !== null && this.state.startDate !== undefined;
        
        // Check if end date is selected
        const hasEndDate = this.state.endDate !== null && this.state.endDate !== undefined;
        
        // Check if report type is selected
        const hasReportType = this.state.utilization_type !== "" && 
                             this.state.utilization_type !== null && 
                             this.state.utilization_type !== undefined;
        
        return hasGroupOrVehicles && hasStartDate && hasEndDate && hasReportType;
    }

    // Process API response and generate columns dynamically
    processResponseData = (response) => {
        if (!response || !Array.isArray(response) || response.length === 0) {
            return { data: [], columns: [] };
        }

        // Get all unique keys from the response objects
        const allKeys = new Set();
        response.forEach(item => {
            Object.keys(item).forEach(key => allKeys.add(key));
        });

        // Generate columns from keys with header mapping
        const columns = Array.from(allKeys).map(key => {
            // Check if there's a mapping for this key
            const mappedName = this.headerMapping[key.toLowerCase()];
            
            // If mapping exists, use it; otherwise format the key
            const displayName = mappedName || 
                (key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '));
            
            return {
                key: key,
                name: displayName
            };
        });

        // Format data - ensure all items have all keys (fill missing with empty string)
        const data = response.map(item => {
            const formattedItem = {};
            columns.forEach(col => {
                formattedItem[col.key] = item[col.key] !== undefined && item[col.key] !== null 
                    ? item[col.key] 
                    : '';
            });
            return formattedItem;
        });

        return { data, columns };
    }

    getReport = () => {
        if (!this.isFormValid()) {
            return;
        }
        
        const { utilization_type, vehicleIds, startDate, endDate } = this.state;
        
        // Convert dates to timestamps
        const starttime = moment(startDate).unix() * 1000;
        const endtime = moment(endDate).unix() * 1000;
        
        // Prepare request body
        const body = {
            vehicleids: vehicleIds,
            utilization_type: utilization_type,
            starttime: starttime,
            endtime: endtime
        };
        
        // Set loading state
        this.setState({ busy: true, errorPage: false, tableData: [], columns: [] });
        
        // Call appropriate API based on utilization_type
        if (utilization_type === "utilization-report") {
            ReportAPIs.getUtilizationReport(body)
                .then((response) => {
                    console.log("Utilization Report Response:", response);
                    
                    // Process response data for table display
                    const { data, columns } = this.processResponseData(response);
                    
                    this.setState({
                        tableData: data,
                        columns: columns,
                        busy: false,
                        errorPage: data.length === 0
                    });
                })
                .catch((error) => {
                    console.error("Utilization Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: []
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch utilization report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
        } 
        // else if (utilization_type === "utilization-graph") {
        //     // TODO: Implement when utilization-graph is ready
        //     ReportAPIs.getUtilizationGraph(body)
        //         .then((response) => {
        //             console.log("Utilization Graph Response:", response);
        //             // TODO: Handle response and display graph
        //         })
        //         .catch((error) => {
        //             console.error("Utilization Graph Error:", error);
        //         });
        // }
    }

    render(){
        return(
            <div className="monthlyReport">
                <div className="mrc-content">
                    <div className="mrcr-group">
                        <div className="mrcrg-selected">
                            <div className="mrc-select-all-toggle">
                                <label className="mrc-toggle-label">
                                    <input
                                        type="checkbox"
                                        checked={this.state.selectAllGroups}
                                        onChange={this.toggleSelectAllGroups}
                                        className="mrc-toggle-checkbox"
                                    />
                                    <span className="mrc-toggle-text">Select All Groups</span>
                                </label>
                            </div>
                            <div className={`mrcrgs-nav ${this.state.selectAllGroups ? 'disabled' : ''}`}>
                                <GroupNav
                                    props={this.state}
                                    navigate={this.navigate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mrc-controls-row">
                        <div className="mrcr-type" ref="reportContainer">
                            <div className="dropdown">
                                <div 
                                    className={this.state.dropdownOpen ? "dropdown-select-active" : "dropdown-select"} 
                                    onClick={this.toggleDropdown}
                                >
                                    {this.state.reportName ? this.state.reportName : "Select Report"}
                                </div>
                                {this.state.dropdownOpen && (
                                    <div className="dropdown-options">
                                        {this.getReportType()}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="mrc-date-selection">
                            <div className="mrcrd-picker">
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.startDate}
                                    onChange={(e) => this.handleStartDate(e)}
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                                    placeholderText="Start Date"
                                />
                            </div>
                            <div className="mrcrd-picker">
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.endDate}
                                    onChange={(e) => this.handleEndDate(e)}
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                                    placeholderText="End Date"
                                />
                            </div>
                        </div>
                        <div className="mrcr-download">
                            <button 
                                className={`mrcr-btn ${!this.isFormValid() ? 'disabled' : ''}`}
                                onClick={this.getReport}
                                disabled={!this.isFormValid()}
                            >
                                Get Report
                            </button>
                        </div>
                    </div>
                    <div className="mrc-table-section">
                        <div className="mrc-group-table">
                            {this.state.tableData && this.state.tableData.length > 0 && this.state.columns.length > 0 ? (
                                <GroupTable
                                    data={this.state.tableData}
                                    columns={this.state.columns}
                                />
                            ) : null}
                            {this.state.busy ? (
                                <div className="mrc-table-loader">
                                    <div className="loading">Loading...</div>
                                </div>
                            ) : null}
                            {this.state.errorPage && !this.state.busy ? (
                                <div className="mrc-error-page">
                                    <div>NO DATA</div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default MonthlyReport;
